import { logger } from '@nanostores/logger'
import { atom } from 'nanostores'

import type { ScheduledMessage } from './types'

const $isScheduledShown = atom<boolean>(false)
const $rescheduleInEdit = atom<null | ScheduledMessage>(null)

$isScheduledShown.listen(isActive => {
	if (!isActive) {
		$rescheduleInEdit.set(null)
	}
})

if (import.meta.env.DEV) {
	logger({
		$isScheduledShown,
		$rescheduleInEdit
	})
}

export { $isScheduledShown, $rescheduleInEdit }
